import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, resolveComponent as _resolveComponent, vShow as _vShow, createVNode as _createVNode, withDirectives as _withDirectives, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-798a3fe8")

_pushScopeId("data-v-798a3fe8")
const _hoisted_1 = {
  class: "checkItem_main",
  id: "checkItemMain"
}
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_checkItem = _resolveComponent("checkItem")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.state.dataList, (item, index) => {
      return _withDirectives((_openBlock(), _createBlock(_component_checkItem, {
        key: index,
        renderData: item,
        dataIndex: index
      }, null, 8, ["renderData", "dataIndex"])), [
        [_vShow, (_ctx.state.tocOnlyShowFlaw && _ctx.getData(item.configItems, 'defectCount') !== '0') || !_ctx.state.tocOnlyShowFlaw]
      ])
    }), 128))
  ]))
})